export default __webpack_public_path__ + "c76b2643400b041d7df83ee609766d08.png";